(() => {
  'use strict';
  const expires = Date.parse('2026-11-01T00:00:00+01:00');
  const selectors = '#pw15-modal,#pw15-overlay,.pw-promo-responsive,.pw-pack__promo,.pw-pack__fine,.pw-cart-complement__promo,.pw-cart-complement__fine,.pw-printer-set__offer,.pw-free-offer__promo,prink-cart-discount';
  let timer;
  const check = () => {
    clearTimeout(timer);
    const remaining = expires - Date.now();
    if (remaining > 0) {
      timer = setTimeout(check, Math.min(remaining, 2147483647));
      return;
    }
    if (!document.getElementById('pw-promotion-expired')) {
      const style = document.createElement('style');
      style.id = 'pw-promotion-expired';
      style.textContent = selectors + '{display:none!important}';
      document.head.append(style);
    }
  };
  check();
  document.addEventListener('visibilitychange', check);
  window.addEventListener('pageshow', check);
})();
